import React from 'react';
import { Link } from 'react-router';
import { Panel } from 'react-bootstrap';
import map from 'lodash/map';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import SeverityLabel from '../../../../components/SeverityLabel/SeverityLabel';
import { formatDateTime } from '../../../../shared/utils/date';
import { formatSupplier, formatEmc } from '../../../../shared/utils/run';
import { manifestNumberFormatter } from '../../../../shared/utils/rowFormatters';

const recoveryActionsFormatter = (cell, row) => {
    if (
        row.manifest.allManifestRecoveryActions &&
        row.manifest.allManifestRecoveryActions.length > 0 &&
        row.abnormality
    ) {
        return (
            <div>
                {row.manifest.allManifestRecoveryActions.map(rec => {
                    if (
                        row.abnormality.runId &&
                        row.abnormality.abnormalityType &&
                        row.abnormality.abnormalityId &&
                        rec.recoveryActionType &&
                        rec.recoveryActionId
                    ) {
                        return (
                            <p key={rec.recoveryActionId}>
                                <Link
                                    to={`runs/${row.abnormality.runId}/abnormality/${
                                        row.abnormality.abnormalityType
                                    }/${row.abnormality.abnormalityId}/recoveryAction/${
                                        rec.recoveryActionType
                                    }/${rec.recoveryActionId}`}
                                >
                                    {rec.name}
                                </Link>
                            </p>
                        );
                    }
                    return null;
                })}
            </div>
        );
    }

    return <div />;
};

const abnormalitiesFormatter = otherAbnormalities => {
    if (otherAbnormalities && otherAbnormalities.length > 0) {
        return (
            <div>
                {map(otherAbnormalities, abn => {
                    if (abn.runId && abn.abnormalityId && abn.abnormalityType) {
                        return (
                            <p key={abn.abnormalityId}>
                                <Link
                                    to={`runs/${abn.runId}/abnormality/${abn.abnormalityType}/${
                                        abn.abnormalityId
                                    }`}
                                >
                                    {abn.name}
                                </Link>
                            </p>
                        );
                    }
                })}
            </div>
        );
    }
    return <div />;
};

const severityFormatter = (cell, row) =>
    row.severity ? <SeverityLabel code={row.severity} /> : '';

export default class AbnormalityManifestsTable extends React.Component {
    render() {
        const {
            manifests,
            hideSeverity = true,
            isPaginated = false,
            onCheckSelect,
            onCheckSelectAll,
            selectedAbnManifestIds,
            validations,
        } = this.props;
        return (
            <Panel>
                {validations.manifests && (
                    <p style={{ color: '#CF142B', margin: 5 }}>{validations.manifests}</p>
                )}
                {validations.pallets && (
                    <p style={{ color: 'orange', margin: 5 }}>{validations.pallets}</p>
                )}
                <BootstrapTable
                    ref="manifests"
                    data={manifests}
                    pagination={isPaginated}
                    hover
                    trClassName="clickable"
                    remote
                    tableStyle={validations.manifests && { border: '#CF142B 2px solid' }}
                    selectRow={{
                        mode: 'checkbox',
                        onSelect: onCheckSelect,
                        onSelectAll: onCheckSelectAll,
                        selected: selectedAbnManifestIds,
                    }}
                >
                    <TableHeaderColumn isKey dataField="abnormalityManifestId" hidden>
                        ID
                    </TableHeaderColumn>
                    <TableHeaderColumn dataField="manifest" dataFormat={manifestNumberFormatter}>
                        Manifest number
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="manifest"
                        dataFormat={manifest =>
                            formatSupplier({
                                supplierCode: manifest.supplierCode,
                                supplierPlantCode: manifest.supplierPlantCode,
                            })
                        }
                    >
                        Supplier
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="manifest"
                        dataFormat={manifest =>
                            formatEmc({
                                emcCode: manifest.emcCode,
                                emcPlantCode: manifest.emcPlantCode,
                            })
                        }
                    >
                        EMC
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="manifest"
                        dataFormat={manifest => manifest.emcDockCode}
                    >
                        Dock
                    </TableHeaderColumn>
                    <TableHeaderColumn dataField="totalPallets" width="175">
                        Impacted # of pallets
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="manifest"
                        dataFormat={manifest => formatDateTime(manifest.connectingRunTime)}
                        dataSort
                    >
                        Connection time
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="manifest"
                        dataFormat={manifest => formatDateTime(manifest.pLaneExit)}
                        dataSort
                    >
                        P-Lane exit
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="manifest"
                        dataFormat={manifest => manifest.orderGroup}
                        dataSort
                        width="125"
                    >
                        Order group
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="severity"
                        dataFormat={severityFormatter}
                        editable={false}
                        hidden={hideSeverity}
                        width="120"
                    >
                        Severity
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="otherAbnormalities"
                        dataSort
                        dataFormat={cell => abnormalitiesFormatter(cell)}
                    >
                        Other abnormalities
                    </TableHeaderColumn>
                    <TableHeaderColumn
                        dataField="manifest"
                        dataSort
                        dataFormat={(cell, row) => recoveryActionsFormatter(cell, row)}
                    >
                        Other recovery actions
                    </TableHeaderColumn>
                </BootstrapTable>
            </Panel>
        );
    }
}
